import FAQ_ANSWERS_EN, { getFaqAnswerEn } from '../data/faqSupportAnswers.en.js';

/**
 * FAQ answers use site-accurate English copy for all locales until
 * localized answer text is reviewed. Questions still come from translations.
 */
export function getFaqAnswer(categoryId, questionId, t) {
  const accurate = getFaqAnswerEn(categoryId, questionId);
  if (accurate) return accurate;
  return t(`faqSupport.questions.${categoryId}.${questionId}.a`);
}

export { FAQ_ANSWERS_EN };
